import React, { useState, useContext } from 'react';
import UserDetailsContext from '../context/userDetails.context';
import LocationsContext from '../context/locations.Context';
import ThemeContext from '../context/theme.Context';
import LoadingContext from '../context/loading.context';
import NotificationContext from '../context/notification.Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import * as Constants from '../modules/constants';


const ManageGroups = function (props) {

    const { locations, activeLocationId, setGroup } = useContext(LocationsContext);
    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { userId, token } = useContext(UserDetailsContext);
    const { showMessage } = useContext(NotificationContext);

    const [groups, setGroups] = useState(initializeGroups);

    const apiHostName = Constants.API_URL;


    function initializeGroups() {
        const groups = {};
        Object.values(locations[activeLocationId].groups).forEach(group => {
            groups[group.id] = { ...group };
            groups[group.id].visible = true;
        });
        return groups;
    }


    function setGroupNameText(groupId, value) {
        setGroups(prevState => {
            return { ...prevState, [groupId]: { ...prevState[groupId], name: value } };
        });
    }

    function updateGroupName(groupId) {

        // Call server and update locations context
        showLoading();
        fetch(apiHostName + '/v1/groups/' + groupId + '?name=' + encodeURIComponent(groups[groupId].name), {
            mode: "cors",
            method: 'PUT',
            headers: { "Authorization": "Bearer " + token }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Network error");
                }
                return response.text();
            })
            .then((result) => {
                // Result contains a simple status text - ignore this...

                // Add new group with ID that was returned from the server:
                setGroups(prevState => {
                    return { ...prevState, [groupId]: { ...prevState[groupId], name: [groups[groupId].name] } };
                });

                // Set locations with new group:
                setGroup(activeLocationId, groups[groupId]);

                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Cannot create new group...");
                console.error(error);
                showMessage({ newMessage: 'Network error' });
                hideLoading();
            });
    }

    function deleteGroup(groupId) {
        if (!window.confirm('Are you sure you want to delete group ' + groups[groupId].name + '?'))
            return;

        // Call server and update locations context
        showLoading();
        fetch(apiHostName + '/v1/groups/' + groupId, {
            mode: "cors",
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + token }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Network error");
                }
                return response.text();
            })
            .then((result) => {
                // Result contains a simple status text - ignore this...

                // Set locations - delete the group:
                groups[groupId].name = '';
                setGroup(activeLocationId, groups[groupId]);  // Empty name means it's going to be deleted...

                // Add new group with ID that was returned from the server:
                setGroups(prevState => {
                    return { ...prevState, [groupId]: { ...prevState[groupId], visible: false } };
                });
                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Cannot create new group...");
                console.error(error);
                showMessage({ newMessage: 'Network error' });
                hideLoading();
            });
    }


    function addGroup() {
        const groupName = window.prompt('Please enter the name for the new group', 'New group');
        if (!groupName)
            return;
        if (groupName.trim().length === 0)
            return;

        // Call server and update locations context
        showLoading();
        fetch(apiHostName + '/v1/groups/' + activeLocationId + '?name=' + encodeURIComponent(groupName), {
            mode: "cors",
            method: 'POST',
            headers: { "Authorization": "Bearer " + token }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Network error");
                }
                return response.json();
            })
            .then((result) => {
                // Result contains the new group - including the ID:

                // Add new group with ID that was returned from the server:
                setGroups(prevState => {
                    const newState = { ...prevState };
                    newState[result.id] = { id: [result.id], name: groupName, devices: null, deviceIDs: [], visible: true };
                    return newState;
                });

                // Set locations with new group:
                setGroup(activeLocationId, result);

                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Cannot create new group...");
                console.error(error);
                showMessage({ newMessage: 'Network error' });
                hideLoading();
            });

    }


    function canManageLocation(location) {
        if (location.owner === userId)
            return true;
        if (location.authorization === 'Manage')
            return true;
        return false;
    }


    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <Card bg={themeContext.theme} text={themeContext.textColor}>
                    <Card.Body>
                        <Card.Title>
                            Manage groups <Button variant='secondary' title="Add new group" disabled={!canManageLocation(locations[activeLocationId])} style={{ marginLeft: '30px' }} onClick={addGroup}><FontAwesomeIcon icon="plus-circle" /></Button>{' '}
                        </Card.Title>
                        <Card.Subtitle>
                            Add, remove or update groups
                        </Card.Subtitle>
                        <Card.Text as="div" style={{ paddingTop: '2em' }}>
                            {Object.values(groups).map(group => {
                                return group.visible ?
                                    <div key={group.id} style={{ display: 'flex', marginBottom: '5px' }}>
                                        <Form.Control type='text' maxLength={100} disabled={!canManageLocation(locations[activeLocationId])} value={group.name} onChange={(e) => { setGroupNameText(group.id, e.target.value) }} />
                                        <Button variant='secondary' title="Update group name" disabled={!canManageLocation(locations[activeLocationId])} onClick={() => updateGroupName(group.id)}><FontAwesomeIcon icon="edit" /></Button>
                                        <Button variant='secondary' title="Delete group" disabled={!canManageLocation(locations[activeLocationId])} style={{ marginLeft: '5px' }} onClick={() => deleteGroup(group.id)}><FontAwesomeIcon icon="trash-alt" /></Button>
                                    </div>
                                    : '';
                            }
                            )
                            }
                        </Card.Text>
                    </Card.Body>
                </Card>

            )}
        </ThemeContext.Consumer>
    );
};

export default ManageGroups;


// WEBPACK FOOTER //
// ./src/components/ManageGroups.js